export default class EstatedOtherFeature {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.feature_type = obj.feature_type;
    this.feature_sq_ft = obj.feature_sq_ft;
  }
}
